const releaseOfPersonalInformationAgreement = {
    "content": "本人擬報名參加財團法人全國認證基金會(下稱「TAF」)舉辦之研討會/訓練課程，茲由TAF告知本人個人資料蒐集、處理、利用等相關事項如下：\n" +
        "一、蒐集之特定目的TAF基於教育或訓練行政、及代為向政府機關及經濟部中小企業申報終身學習時數、醫事檢驗學會申報醫事檢驗學分之特定目的蒐集、處理、利用本人之個人資料。\n" +
        "二、蒐集及處理之個人資料類別\n" +
        " (一) 辨識個人者。如中英文姓名、身分證字號、相關證書編號、通訊聯絡資訊(E-mail、聯絡住址、電話)等。\n" +
        " (二) 個人描述。如服務單位名稱、部門等。\n" +
        " (三) 其他。如發票開立相關資訊等。\n" +
        "三、利用之期間、地區、對象及方式本人同意TAF於特定目的存續期間、相關法令或契約約定就個人資料之保存期間、TAF因執行業務必須之保存期間，在台灣、澎湖、金門、馬祖地區與TAF有業務往來之機構、與TAF往來之合作單位，得以自動化機器或其他非自動化方式利用本人個人資料。\n" +
        "四、本人知悉就本人提供之個人資料得自費向TAF行使下列權利：\n" +
        " (一)查詢或請求閱覽。\n" +
        " (二)請求製給複製本。\n" +
        " (三)請求補充或更正。\n" +
        " (四)請求停止蒐集、處理或利用。\n" +
        " (五)請求刪除。\n" +
        "五、本人得自由選擇是否提供本人個人資料，但本人提供之個人資料，如有內容不完整，或經TAF發現不足以確認本人身分真實性，或其他個人資料冒用，個人資料不實等情形，可能喪失參與訓練課程資格、錯誤申報學習時數或或檢驗學分等相關權利。\n" +
        "本人同意TAF基於上述特定目的蒐集或處理本人個人資料，並於特定目的之必要範圍內利用本人個人資料。",
    "waring": "[聲明：請報名人親自報名，如未經他人同意擅自使用他人個人資料報名，將有相關民刑事責任。]"
};

export default releaseOfPersonalInformationAgreement;